import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Presentation from './pages/Presentation';
import ProgramsList from './pages/ProgramsList';
import ProgramDetail from './pages/ProgramDetail';
import Beneficiaires from './pages/Beneficiaires';
import Partenaires from './pages/Partenaires';
import Actualites from './pages/Actualites';
import Contact from './pages/Contact';
import Inscription from './pages/Inscription';
import Connexion from './pages/Connexion';
import MotDePasseOublie from './pages/MotDePasseOublie';
import ReinitialisationMotDePasse from './pages/ReinitialisationMotDePasse';
import Dashboard from './pages/Dashboard';
import Profil from './pages/Profil';
import FaireUnDon from './pages/FaireUnDon';
import FAQ from './pages/FAQ';
import Callback from './pages/Callback';
import AdminDashboard from './pages/AdminDashboard';
import AdminPrograms from './pages/AdminPrograms';
import AdminUsers from './pages/AdminUsers';
import AdminActualites from './pages/AdminActualites';
import './App.scss';

function AppContent() {
  const location = useLocation();
  const isMemberArea = location.pathname.startsWith('/dashboard') || location.pathname.startsWith('/member') || location.pathname.startsWith('/admin');

  return (
    <div className="App">
      <ScrollToTop />
      {!isMemberArea && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/presentation" element={<Presentation />} />
        <Route path="/programmes" element={<ProgramsList />} />
        <Route path="/programmes/:id" element={<ProgramDetail />} />
        <Route path="/beneficiaires" element={<Beneficiaires />} />
        <Route path="/partenaires" element={<Partenaires />} />
        <Route path="/actualites" element={<Actualites />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/inscription" element={<Inscription />} />
        <Route path="/connexion" element={<Connexion />} />
        <Route path="/mot-de-passe-oublie" element={<MotDePasseOublie />} />
        <Route path="/reinitialiser-mot-de-passe" element={<ReinitialisationMotDePasse />} />
        <Route path="/faire-un-don" element={<FaireUnDon />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/callback" element={<Callback />} />
        <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/member/profil" 
          element={
            <ProtectedRoute>
              <Profil />
            </ProtectedRoute>
          } 
        />
        <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
        <Route path="/admin/programmes" element={<AdminRoute><AdminPrograms /></AdminRoute>} />
        <Route path="/admin/utilisateurs" element={<AdminRoute><AdminUsers /></AdminRoute>} />
        <Route path="/admin/actualites" element={<AdminRoute><AdminActualites /></AdminRoute>} />
      </Routes>
      {!isMemberArea && <Footer />}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;
